/**
 * src/shell/main.tsx — 应用入口。
 *
 * 启动序列（设计稿 §2 Phase 0）：种子初始化（幂等）→ 灌存档快照缓存 → 渲染。
 * 首启（本次写入种子）落 S0 标题屏；非首启直落 S1 驾驶舱（恢复协议在 App 内触发）。
 */

import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { ensureInitialized } from './save/seed'
import { initSaveCache } from './gm-client/save-cache'
import { App } from './ui/App'
import './ui/styles.css'

async function boot(): Promise<void> {
  const firstRun = ensureInitialized()
  await initSaveCache()
  const container = document.getElementById('root')
  if (!container) throw new Error('缺少 #root 容器')
  createRoot(container).render(
    <StrictMode>
      <App firstRun={firstRun} />
    </StrictMode>,
  )
}

void boot()
